import React from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import withHandlers from 'recompose/withHandlers';

const AdminNavigationItem = ({title, href, onClick}) => (
	<Button color="contrast" href={href} onClick={onClick}>
		{title}
	</Button>
);

AdminNavigationItem.propTypes = {
	title: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired
};

const enhance = withHandlers({
	onClick: ({history, href}) => e => {
		e.preventDefault();

		history.push(href);
	}
});

export default enhance(AdminNavigationItem);



// WEBPACK FOOTER //
// ./src/client/components/admin/layout/navigation/navigation-item.jsx